<template>
  <div>
    <div class="route-title">
      <h1>{{ $t('basket.title') }}</h1>
      <template v-if="basket.isAdmin">
        <template v-if="basket.isCustom">
          <svg @click="setCustom(false)" xmlns="http://www.w3.org/2000/svg" height="2em"
               width="2em" viewBox="0 0 576 512">
            <title>{{ $t('basket.toStandard') }}</title>

            <path
                d="M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"/>

          </svg>
          <b style="color: red">{{ $t('basket.customQuote') }}</b>
        </template>
        <template v-else>
          <svg @click="setCustom(true)" xmlns="http://www.w3.org/2000/svg" height="2em" width="2em"
               viewBox="0 0 576 512">
            <title>{{ $t('basket.toCustomQuote') }}</title>
            <path
                d="M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"/>
          </svg>
          <span>{{ $t('basket.standardQuote') }}</span>
        </template>
      </template>
    </div>
    <span class="items-block loader" v-if="loading"></span>
    <template v-else>
      <div class="component-container">
        <div class="items-block" v-if="basket.products && Object.keys(basket.products).length > 0">
          <template v-if="basket.isCustom">
            <div style="display: flex; text-align: center; gap: 8px">
              <span style="min-width: 50px"></span>
              <div style="padding: 10px; flex: 5">{{ $t('basket.productName') }}</div>
              <div style="padding: 10px; flex: 1">{{ $t('basket.amount') }}</div>
              <div style="padding: 10px; flex: 3">{{ $t('basket.unitPriceExcl') }}</div>
              <div style="padding: 10px; flex: 3">{{ $t('basket.unitPriceIncl') }}</div>
              <div style="padding: 10px; flex: 3">{{ $t('basket.totalExcl') }}</div>
              <span style="font-size: 18px; visibility: hidden" class="delete"
                    v-html="IconHelper.ICON_REMOVE"></span>
            </div>
            <div class="custom-item" style="gap: 8px" v-for="(cartItem, index) in basket.customRows" :key="index">
              <svg v-if="cartItem.productId" xmlns="http://www.w3.org/2000/svg" height="1.2em" width="1.2em"
                   viewBox="0 0 320 512">
                <title>{{ $t('basket.isProduct') }}</title>
                <path
                    d="M0 96C0 60.7 28.7 32 64 32h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 96zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"/>
              </svg>
              <span v-else style="min-width: 50px"></span>
              <input style="padding: 10px; flex: 5" type="text" @change="changeCustomItem(cartItem, 'title', $event)"
                     :value="cartItem.title">
              <input style="padding: 10px; flex: 1" @change="changeCustomItem(cartItem, 'amount', $event)" type="text"
                     :value="cartItem.aantal">
              <span style="padding: 10px; flex: 3; display: flex; align-items: center">
                <span class="input-valuta">{{ this.basket.valuta }}</span>
                <input style="text-align: center; text-indent: 30px;"
                       @change="changeCustomItem(cartItem, 'excl', $event)" type="text"
                       :value="number_format(cartItem.bestelprijs, 4, ',', '.')">
              </span>
              <span style="padding: 10px; flex: 3; display: flex; align-items: center">
                <span class="input-valuta">{{ this.basket.valuta }}</span>
                <input style="text-align: center; text-indent: 30px;"
                       @change="changeCustomItem(cartItem, 'incl', $event)" type="text"
                       :value="getCustomPriceIncl(cartItem)">
              </span>
              <span style="padding: 10px; flex: 3; display: flex; align-items: center">
                <span class="input-valuta">{{ this.basket.valuta }}</span>
                <input style="text-align: center; text-indent: 30px;" readonly type="text"
                       :value="customTotal(cartItem.aantal, parseFloat(cartItem.bestelprijs))">
              </span>
              <span style="font-size: 18px" @click="removeCustomRow(index)" class="delete" title="Regel verwijderen"
                    v-html="IconHelper.ICON_REMOVE"></span>
            </div>
          </template>
          <template v-else v-for="cartItem in basket.products">
            <div class="cart-item mobile"
                 :style="[Object.keys(basket.products).length > 1 ? 'padding-bottom: 25px; border-bottom: 1px solid #C9C9CC':'']">
              <img @click="goToProduct(cartItem.url)" :src="cartItem?.option_img || cartItem.img_large"
                   :alt="cartItem.img_alt">
              <div class="info">
                <a :href="cartItem.url" class="name">{{ cartItem.name }}</a>
                <template v-if="cartItem.option_a && cartItem.option_b">
                  <span class="option"><b>{{ $t('basket.teamA') }}:</b> {{ cartItem.option_a }}</span>
                  <span class="option"><b>{{ $t('basket.teamB') }}:</b> {{ cartItem.option_b }}</span>
                </template>
                <span class="color">{{ $t('basket.color') }}: <span :style="['font-weight: normal']">{{
                    cartItem.color
                  }}</span></span>
              </div>
              <span style="font-size: 18px" @click="modalItemId = cartItem.product_id" class="delete"
                    v-html="IconHelper.ICON_REMOVE"></span>
              <div class="amount">
                <button :disabled="cartItem.disabled || cartItem.amount == 1"
                        @click="updateItemAmount(cartItem, 'decrease')"
                        v-html="(cartItem.disabled || cartItem.amount == 1) ? IconHelper.ICON_MINUS_DISABLED : IconHelper.ICON_MINUS"></button>
                <input v-model.number="cartItem.amount" type="number" min="1" max="999"
                    @input="updateItemAmount(cartItem, 'set', cartItem.amount)"
                    @change="updateItemAmount(cartItem, 'set', cartItem.amount)"/>
                <button :disabled="cartItem.disabled" @click="updateItemAmount(cartItem, 'increase')"
                        v-html="IconHelper.ICON_PLUS"></button>
              </div>
              <span class="price">{{ cartItem.item_excl }}</span>
              <template v-if="cartItem?.included_accessories.length > 0">
                <p class="included_title" style="font-size: 14px; font-weight: bold">{{$t('basket.included')}}:</p>
                <ul class="included_items" style="font-size: 12px">
                  <li v-for="includedItem in cartItem.included_accessories">
                    <span style="color: var(--brown);">{{ includedItem.count }}x </span>
                    <a title="Bekijk product" :href="includedItem.url">{{ includedItem.code }} </a>
                    <s style="color: red; margin-left: 4px"> {{ includedItem.price }}</s> {{ $t('free') }}
                    <a title="Bekijk product" :href="includedItem.url"><i class="fa fa-link"></i></a>
                  </li>
                </ul>
              </template>
            </div>
            <div class="cart-item desktop"
                 :style="[Object.keys(basket.products).length > 1 ? 'padding-bottom: 25px; border-bottom: 1px solid #C9C9CC':'']">
              <img @click="goToProduct(cartItem.url)" :src="cartItem?.option_img || cartItem.img_large"
                   :alt="cartItem.img_alt">
              <div class="info">
                <a :href="cartItem.url" class="name">{{ cartItem.name }}</a>
                <template v-if="cartItem.option_a && cartItem.option_b">
                  <span class="option"><b>{{ $t('basket.teamA') }}:</b> {{ cartItem.option_a }}</span>
                  <span class="option"><b>{{ $t('basket.teamB') }}:</b> {{ cartItem.option_b }}</span>
                </template>
                <span v-if="cartItem?.color" class="color">{{ $t('basket.color') }}: <span
                    :style="['font-weight: normal']">{{ cartItem.color }}</span></span>
                <template v-if="cartItem?.included_accessories.length > 0">
                  <p style="font-size: 14px; font-weight: bold">{{$t('basket.included')}}:</p>
                  <ul style="font-size: 12px">
                    <li v-for="includedItem in cartItem.included_accessories">
                      <span style="color: var(--brown);">{{ includedItem.count }}x </span>
                      <a title="Bekijk product" :href="includedItem.url">{{ includedItem.code }} </a>
                      <s style="color: red; margin-left: 4px"> {{ includedItem.price }}</s> {{ $t('free') }}
                      <a title="Bekijk product" :href="includedItem.url"><i class="fa fa-link"></i></a>
                    </li>
                  </ul>
                </template>
              </div>
              <div class="quantity">
                <div class="amount">
                  <template v-if="cartItem.type === 'move'">
                    <input v-model="cartItem.amount" type="number" readonly/>
                  </template>
                  <template v-else>
                    <button :disabled="cartItem.disabled || cartItem.amount == 1"
                            @click="updateItemAmount(cartItem, 'decrease')"
                            v-html="(cartItem.amount == 1) ? IconHelper.ICON_MINUS_DISABLED : IconHelper.ICON_MINUS"></button>
                    <input v-model.number="cartItem.amount" type="number" min="1" max="99"
                           @change="updateItemAmount(cartItem, 'set', cartItem.amount)"
                           @input="updateItemAmount(cartItem, 'set', cartItem.amount)"/>
                    <button :disabled="cartItem.disabled  || cartItem.amount == 99"
                            @click="updateItemAmount(cartItem, 'increase')"
                            v-html="(cartItem.amount == 99) ? IconHelper.ICON_PLUS_DISABLED : IconHelper.ICON_PLUS"></button>
                  </template>
                </div>
                <div class="delete-txt" @click="setModalItemId(cartItem)">
                  <span class="delete" v-html="IconHelper.ICON_REMOVE"></span>
                  <span>{{ $t('basket.remove') }}</span>
                </div>
              </div>
              <span class="price">{{ cartItem.item_excl }}</span>
            </div>
            <Modal :classes="'desktop'" @keydown.esc="modalItemId = null" :open="openModal(cartItem)">
              <template v-slot:modal-content>
                <div class="modal-message">
                  <h2>{{ $t('basket.deleteProduct') }}</h2>
                  <div class="buttons">
                    <a class="confirm" @click="removeItem(cartItem)">{{ $t('basket.confirm') }}</a>
                    <a class="cancel" @click="modalItemId = null">{{ $t('basket.cancel') }}</a>
                  </div>
                </div>
              </template>
            </Modal>
          </template>
          <div v-if="basket.isAdmin && basket.isCustom">
            <button class="btn-add" @click="addCustomRow">
              <svg xmlns="http://www.w3.org/2000/svg" height="1.2em" width="1.2em" viewBox="0 0 448 512"
                   style="margin-right: 8px;">
                <path
                    d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/>
              </svg>
              {{ $t('basket.addRow') }}
            </button>
          </div>
        </div>
        <div v-else>
          {{ $t('basket.noProductsInCart') }}
        </div>

        <div class="block-right" v-if="basket.products && Object.keys(basket.products).length > 0">
          <div class="summary">
            <template v-if="basket.isCustom">
              <div class="subtotal">
                <span>{{ $t('basket.subtotal') }}</span>
                <span class="value"><b>{{ basket.valuta + ' ' + customTotalExcl }}</b></span>
              </div>
              <div class="tax">
                <span>{{ $t('basket.vat') }} ({{ basket.vatPercentage }}%)</span>
                <span class="value"><b>{{ basket.valuta + ' ' + customTotalVat }}</b></span>
              </div>
              <div class="total">
                <span>{{ $t('basket.total') }}</span>
                <span class="value"><b>{{ basket.valuta + ' ' + customTotalIncl }}</b></span>
              </div>
            </template>
            <template v-else>
              <div v-for="product in basket.products" class="product-line">
                <span>{{ product.name }}</span>
                <div class="price">
                  <span class="text-brown">{{ product.item_excl }}</span>
                  <span class="text-brown">x{{ product.amount }}</span>
                  <b class="total-price">{{ product.price_excl }}</b>
                </div>
              </div>
              <p v-if="basket.benbOnly" style="margin-top: 8px; color: var(--orange)">{{ $t('basket.benbShippingRule')}}</p>
              <div v-if="basket.kwantumKortingExcl" class="discount">
                <span>{{ $t('basket.quantityDiscount') }}</span>
                <span class="value"><b>{{ basket.kwantumKortingExcl }}</b></span>
              </div>
              <div v-if="basket.dealerRow" class="discount">
                <span>{{ basket.dealerRow.title }}</span>
                <b class="value">{{ basket.dealerAmount }}</b>
              </div>
              <div class="subtotal border-top">
                <span>{{ $t('basket.subtotal') }}</span>
                <span v-if="basket.benbOnly" class="value"><b>{{ basket.totalExclNoShipping}}</b></span>
                <span v-else class="value"><b>{{ basket.totalExcl }}</b></span>
              </div>
              <div class="tax">
                <span>{{ $t('basket.vat') }} ({{ basket.vatPercentage }}%)</span>
                <span v-if="basket.benbOnly" class="value"><b>{{ basket.totalVatNoShipping }}</b></span>
                <span v-else class="value"><b>{{ basket.totalVat }}</b></span>
              </div>
              <div class="total">
                <span>{{ $t('basket.total') }}</span>
                <span v-if="basket.benbOnly" class="value"><b>{{ basket.totalInclNoShipping }}</b></span>
                <span v-else class="value"><b>{{ basket.totalIncl }}</b></span>
              </div>
            </template>

            <router-link :to="{ name: 'contact-details' }" @click="setType('Bestelling')">
              <button class="gsd-btn gsd-btn-secondary">{{ $t('basket.order') }}</button>
            </router-link>
            <router-link :to="{ name: 'contact-details' }" @click="setType('Offerte')">
              <button class="gsd-btn gsd-btn-tertiary">{{ $t('requestQuote') }}</button>
            </router-link>
          </div>
          <div class="payment-methods-compact">
            <img :src="icons + 'ideal.svg'" alt="ideal" title="ideal">
            <img :src="icons + 'bancontact.svg'" alt="bancontact" title="bancontact">
            <img :src="icons + 'kbc.svg'" alt="kbc" title="kbc">
            <img :src="icons + 'trustly.svg'" alt="trustly" title="trustly">
          </div>
          <div class="payment-methods">
            <img :src="icons + 'ideal.svg'" alt="ideal" title="ideal">
            <img :src="icons + 'bancontact.svg'" alt="bancontact" title="bancontact">
            <img :src="icons + 'kbc.svg'" alt="kbc" title="kbc">
            <img :src="icons + 'trustly.svg'" alt="trustly" title="trustly">
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import IconHelper from '@/helpers/IconHelper';
import Modal from '../components/general/Modal.vue';
import {number_format} from "../helpers/NumberHelper";

export default {
  name: "Basket",
  components: {Modal, IconHelper},
  data() {
    return {
      IconHelper,
      public: public_dir, //deze mag niet hetzelfde heten, anders pikt ie t niet in de productie build
      icons: frontend_dir + '/icons/',
      loading: true,
      basket: {},
      modalItemId: null,
      itemsInCartElements: document.getElementsByClassName("items-in-cart"),
    };
  },
  watch: {},
  async mounted() {
    this.loading = true;
    try {
      await this.getBasket();
    } catch (e) {
      this.$handleError(e);
    } finally {
      this.loading = false;
    }
  },
  computed: {
    customTotalExcl() {
      let totalExcl = 0;
      let customRows = this.basket.customRows;
      Object.keys(customRows).forEach((index) => {
        totalExcl += parseFloat(customRows[index].bestelprijs) * parseFloat(customRows[index].aantal);
      });

      return number_format(totalExcl, 2, ',', '.');
    },
    customTotalIncl() {
      let totalExcl = 0;
      let customRows = this.basket.customRows;
      Object.keys(customRows).forEach((index) => {
        totalExcl += parseFloat(customRows[index].bestelprijs * customRows[index].aantal);
      });

      return number_format(totalExcl * ((parseFloat(this.basket.vatPercentage) + 100) / 100), 2, ',', '.');
    },
    customTotalVat() {
      let totalExcl = 0;
      let customRows = this.basket.customRows;
      Object.keys(customRows).forEach((index) => {
        totalExcl += parseFloat(customRows[index].bestelprijs * customRows[index].aantal);
      });

      let totalIncl = totalExcl * ((parseFloat(this.basket.vatPercentage) + 100) / 100);


      return number_format((totalIncl - totalExcl), 2, ',', '.');
    }
  },
  methods: {
    number_format,
    async getBasket() {
      let existingTender = {};

      // open existing tender check
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('offerte_nummer') && urlParams.has('offerte_email')) {
        existingTender.offerteNummer = urlParams.get('offerte_nummer');
        existingTender.offerteEmail = urlParams.get('offerte_email');
      }

      try {
        const response = await axios.post(`/${this.$sessionLang}/api/getbasket`, {
          existingTender: existingTender,
        });


        if (response.data.data.message) {
          alert(response.data.data.message);
        }

        if (response.data.data.redirect) {
          window.location.href = response.data.data.redirect;
        }

        this.basket = response.data.data.basket;

        for (let i = 0; i < this.itemsInCartElements.length; i++) {
          this.itemsInCartElements[i].textContent = this.basket.productCount;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    async removeItem(cartItem) {
      let productId = cartItem.product_id;
      if (cartItem.option_key) {
        productId += '_' + cartItem.option_key;
      }

      try {
        await axios.post(`/${this.$sessionLang}/api/removeProduct`, {
          product_id: productId,
        });

        await this.getBasket();
      } catch (error) {
        this.$handleError(error);
      }

      this.modalItemId = null
    },
    async updateItemAmount(cartItem, action, amount) {
      if (amount <= 0) amount = cartItem.amount = 1; // standaard op 1 zetten

      if ((cartItem.amount == 1 && action == 'decrease') || (action == 'set' && amount == 0)) {
        return;
      }

      let productId = cartItem.product_id;
      if (cartItem.option_key) {
        productId += '_' + cartItem.option_key;
      }

      let newAmount = parseFloat(cartItem.amount);
      if (action == 'decrease') {
        newAmount -= 1;
      }
      else if (action == 'increase') {
        newAmount += 1;
      }
      else if (action == 'set') {
        newAmount = amount;
      }

      cartItem.disabled = true;
      try {
        await axios.post(`/${this.$sessionLang}/api/updateproductamount`, {
          product_id: productId,
          new_amount: newAmount,
        });

        await this.getBasket();
      } catch (error) { // Handle errors if needed
        this.$handleError(error);
      }

      cartItem.disabled = false;

    },
    goToProduct(url) {
      window.location = url;
    },
    async setType(type) {
      try {
        await axios.post(`/${this.$sessionLang}/api/settype`, {
          type: type,
        });

        await this.getBasket();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async setCustomRows() {
      this.loading = true;

      try {
        await axios.post(`/${this.$sessionLang}/api/setcustomrows`, {
          customRows: this.basket.customRows
        });

        await this.getBasket();
      } catch (error) {
        this.$handleError(error);
      }
      this.loading = false;
    },
    addCustomRow() {
      let newRow = {
        title: '',
        aantal: 1,
        bestelprijs: 0,
        bestelprijsinc: 0,
      }

      this.basket.customRows.push(newRow);
    },
    async removeCustomRow(key) {
      this.loading = true;

      if (confirm('Regel verwijderen?')) {
        this.basket.customRows.splice(key, 1);
        await this.setCustomRows();
      }

      this.loading = false;
    },
    async setCustom(bool) {
      this.loading = true;

      try {
        await axios.post(`/${this.$sessionLang}/api/setcustom`, {
          bool: bool,
        });

        await this.getBasket();
      } catch (error) {
        this.$handleError(error);
      }

      this.loading = false;
    },
    changeCustomItem(item, changed, event) {
      this.loading = true;

      switch(changed) {
        case 'title':
          item.title = event.target.value;
          break;
        case 'amount':
          item.aantal = Math.round(event.target.value);
          break;
        case 'incl':
          let priceInc = parseFloat(event.target.value).toFixed(4);
          item.bestelprijs = priceInc / ((parseFloat(this.basket.vatPercentage) + 100) / 100).toFixed(4);
          break;
        case 'excl':
          item.bestelprijs = event.target.value;
          break;
      }

      this.setCustomRows();

      this.loading = false;
    },
    customTotal(amount, price_excl) {
      let total = parseFloat(amount) * parseFloat(price_excl);
      return number_format(total, 4, ',', '.');
    },
    getCustomPriceIncl(cartItem) {
      return number_format((parseFloat(cartItem.bestelprijs) * ((parseFloat(this.basket.vatPercentage) + 100) / 100)), 4, ',', '.');
    },
    setModalItemId(cartItem) {
      if (cartItem?.option_key) {
        this.modalItemId = cartItem.option_key;
        return;
      }

      this.modalItemId = cartItem.product_id;
    },
    openModal(cartItem) {
      if (cartItem?.option_key) {
        return this.modalItemId == cartItem.option_key;
      }

      return this.modalItemId == cartItem.product_id;
    }
  },
}
</script>

<style scoped>
ul {
  list-style: none;
}

.modal-message {
  font: var(--bold-14-20);
  border-radius: 4px;
  text-align: center;
  max-width: 500px;
}

.modal-message h2 {
  padding: 16px;
  font: var(--bold-22-28);
  background-color: var(--brown);
  color: var(--white);
}

.buttons {
  display: flex;
  flex-direction: column;
  background: white;
}

.buttons a {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  width: 100%;
  color: var(--orange);
}

.buttons .confirm {
  font: var(--medium-16);
  color: black;
  border-bottom: 1px solid var(--brown);
}

.buttons a:active {
  position: inherit;
}

.buttons .confirm:hover,
.buttons .cancel:hover {
  background-color: var(--beige);
}

.buttons .confirm:focus-visible,
.buttons .cancel:focus-visible {
  outline: none;
}

.input-valuta {
  position: absolute;
  border: 1px solid #C8C8CC;
  border-radius: 8px;
  padding: 12px;
  background-color: #C8C8CC47;
}

div.items-block {
  flex-grow: 1;
}

.route-title {
  margin-bottom: 1em;
  display: flex;
  justify-content: flex-start;
  gap: 16px;
  align-items: center;
}

.route-title svg {
  cursor: pointer;
}

.custom-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-item input {
  opacity: 1;
}

.custom-item svg {
  min-width: 50px;
}

.custom-item .delete {
  cursor: pointer;
}

.product-line .price {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 8px;
  white-space: nowrap;
}

.product-line .text-brown {
  color: var(--brown);
  font: var(--medium-14);
}

.product-line .total-price {
  flex-grow: 1;
  text-align: end
}

.btn-add {
  margin: 16px 0 0 50px;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #C8C8CC;
  cursor: pointer
}

.btn-add:hover {
  background-color: #C8C8CC;
}

.cart-item {
  display: grid;
  gap: 8px 16px;
  grid-template-columns: 2fr 6fr 1fr;
  grid-template-areas:
      "img info del"
      "img info del"
      "amount price price"
      "included_title included_title included_title"
      "included_items included_items included_items";
  margin-bottom: 25px;
}

.cart-item.desktop,
.custom-item.desktop,
.payment-methods-compact {
  display: none;
}

.cart-item > img {
  grid-area: img;
  aspect-ratio: 3/2;
  object-fit: cover;
  border-radius: 4px;
  max-width: 134px;
  cursor: pointer;
}

.cart-item .info {
  display: flex;
  flex-direction: column;
  grid-area: info;
}

.cart-item .info .name {
  font: var(--bold-16-20);
  word-break: break-word;
  cursor: pointer;
}

.cart-item .info .option {
  font: var(--normal-12-14);
}

.cart-item .info .color {
  padding-top: 5px;
  font: var(--bold-14-20);
}

.cart-item .delete {
  grid-area: del;
  align-self: flex-start;
  justify-self: flex-end;
  cursor: pointer;
}

.cart-item .amount {
  grid-area: amount;
  min-width: 134px;
}

.cart-item .price {
  grid-area: price;
  font: var(--bold-16-20);
  align-self: center;
}

.cart-item .included_title {
  grid-area: included_title;
}

.cart-item .included_items {
  grid-area: included_items;
}

.amount {
  display: flex;
  width: 100%;
  font: var(--medium-16);
  border: 1px solid #C8C8CC;
  border-radius: 8px;
  margin-top: 5px;
  max-width: 134px;
}

.amount button {
  width: 25%;
  min-width: 35px;
  color: var(--brown);
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
}

.amount span {
  margin: auto;
  display: block;
}

.amount input {
  border: none;
  text-align: center;
  opacity: 1;
  font: var(--medium-16);
}

.amount input::-webkit-outer-spin-button,
.amount input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  -moz-appearance: textfield;
  margin: 0;
}

.amount input {
  -moz-appearance: textfield;
}

.amount input:focus {
  outline: none;
}

.summary {
  margin-top: 50px;
  padding: 25px;
  border: 1px solid #C9C9CC;
  border-radius: 8px;
}

.border-top {
  padding-top: 15px;
  margin-top: 15px;
  border-top: 1px solid #C9C9CC;
}

.summary .tax {
  padding: 0 0 15px 0;
  border-bottom: 1px solid #C9C9CC;
}

.summary .total {
  padding: 15px 0;
}

.summary .discount {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  white-space: nowrap;
}

.summary .subtotal,
.summary .tax,
.summary .total {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}

.summary .subtotal,
.summary .tax {
  font: var(--medium-16);
}

.summary .total {
  font: var(--medium-22-32);
}

.value {
  white-space: nowrap;
  text-align: right;
  flex-grow: 1;
  margin-bottom: 8px;
}

.gsd-btn {
  width: 100%;
  font: var(--bold-16-20);
}

.gsd-btn-secondary {
  margin: 20px 0;
}

.payment-methods {
  margin-top: 25px;
  display: flex;
  gap: 16px;
  justify-content: center;
}

.payment-methods img {
  height: 36px;
}

.loader {
  display: block;
  width: 48px;
  height: 48px;
  margin: auto;
  border-radius: 50%;
  position: relative;
  animation: rotate 1s linear infinite;
}

.loader::before,
.loader::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 5px solid var(--orange);
  animation: prixClipFix 2s linear infinite;
}

.loader::after {
  transform: rotate3d(90, 90, 0, 180deg);
  border-color: var(--black);
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }
  50% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }
  75%, 100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
  }
}

@media (min-width: 1140px) {
  .component-container {
    display: flex;
    flex-direction: row;
    gap: 32px;
  }

  .summary {
    margin-top: 0;
  }

  .custom-item.desktop {
    display: flex;
  }

  .cart-item.desktop {
    display: grid;
  }

  .component-container .payment-methods,
  .cart-item.mobile,
  .custom-item.mobile {
    display: none;
  }

  .cart-item {
    display: grid;
    gap: 32px;
    grid-template-columns: 1fr 3fr 1fr 1fr;
    grid-template-areas: "img info qntty price";
    padding-bottom: 32px;
    border-bottom: 1px solid rgba(200, 200, 204, 0.1);
  }

  .cart-item > img {
    grid-area: img;
    aspect-ratio: 3/2;
    object-fit: cover;
    border-radius: 4px;
    max-width: 180px;
    cursor: pointer;
  }

  .cart-item .info {
    display: flex;
    flex-direction: column;
    grid-area: info;
    margin-top: 5px;
  }

  .cart-item .info .name {
    font: var(--bold-22-28);
    word-break: break-word;
  }

  .cart-item .info .color {
    font: var(--bold-14-20);
  }

  .delete-txt .delete svg {
    max-height: 100%;
  }

  .cart-item .delete-txt {
    cursor: pointer;
    display: flex;
    margin-top: 5px;
    justify-content: center;
    align-items: center;
    color: #C9C9CC;
    font: var(--normal-12-14);
    gap: 5px;
  }

  .cart-item .quantity {
    grid-area: qntty;
  }

  .cart-item .amount {
    min-width: 134px;
    margin-top: 0;
  }

  .cart-item .price {
    grid-area: price;
    font: var(--bold-16-20);
    margin-top: 12px;
    align-self: flex-start;
    justify-self: end;
  }

  .payment-methods-compact {
    margin-top: 25px;
    display: flex;
    justify-content: center;
    gap: 8px;
  }

  .payment-methods-compact img {
    height: 32px;
  }
}

</style>